import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useAuthInfo } from 'auth';

export const withoutLogin = (WrappedComponent: React.FC) => {
  const WithoutLogin = () => {
    const { isLoggedIn, isAuthChecking } = useAuthInfo();
    const history = useHistory();

    useEffect(() => {
      if (isAuthChecking) return;

      // 既にログイン済ならトップページへ
      if (isLoggedIn) {
        history.replace('/project');
      }
    }, [isLoggedIn, isAuthChecking]);

    return isAuthChecking || isLoggedIn ? null : <WrappedComponent />;
  };

  return WithoutLogin;
};
